//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";

function generateSanitizedCamelIshCase(str) {
    // sanitize: removes non alphanumeric chars except "_"
    // camel-ish case: unlike camel case this function preserves uppercase letters inside words
    str = str.replace(/[^a-zA-Z0-9 _]/g, "");
    return str.split(" ").reduce((acc, word, index) => {
        if (!index) return `${acc}${(word[0] && word[0].toLowerCase()) || ""}${word.slice(1)}`;
        return `${acc}${(word[0] && word[0].toUpperCase()) || ""}${word.slice(1)}`;
    }, "");
}

export default {
    name: "CreateColumnModal",
    components: {
        AQDropdown,
        AQInput,
        AQModal,
        AQCheckbox,
        AQDialog,
        AQCard
    },
    props: {
        addAttInEntity: { type: Boolean, default: false },
        entityData: {
            type: Object,
            default: () => {
            }
        },
        atributesList: {
            type: Array,
            default: () => []
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        attDataToEdit: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            showColumnModal: true,
            columnType: "",
            defaultSource: "string",
            sourceOptions: [
                {
                    value: "serial",
                    label: "Serial"
                },
                {
                    value: "string",
                    label: "String"
                },
                {
                    value: "integer",
                    label: "Integer"
                },
                {
                    value: "decimal",
                    label: "Decimal"
                },
                {
                    value: "datetime",
                    label: "Date-time"
                },
                {
                    value: "date",
                    label: "Date"
                },
                {
                    value: "time",
                    label: "Time"
                },
                {
                    value: "BOOLEAN",
                    label: "Boolean"
                }
            ],
            wrongPattern: false,
            wrongPatternErrCode: false,
            addAnother: false,
            reset: false,
            duplicatedName: false,
            duplicatedCode: false,
            updateComponent: 0,
            attUpdated: false,
            headerActions: [{
                label: this.$t("globalDataModel.deleteEntity"),
                itemDisabled: this.attDataToEdit && this.attDataToEdit.field === "id",
                tooltipProps: this.attDataToEdit && this.attDataToEdit.field === "id"
                    ? { tooltipContent: this.$t("globalDataModel.deleteTooltipColumn"), direction: "left" }
                    : null
            }],
            column: {
                label: "",
                code: ""
            },
            showDialog: false,
            emptyName: false,
            emptyCode: false
        };
    },
    computed: {
        save() {
            return {
                label: this.$t("admin.usersAndRoles.permissionsModal.saveBtn")
            };
        },
        sourceOptionsComp() {
            let optionsToReturn = this.sourceOptions;
            if (!this.isEdit) {
                optionsToReturn = this.sourceOptions.filter(elem => elem.value !== "serial");
            }
            return optionsToReturn;
        },
        errorLabel() {
            let errorMsg;
            if (!this.column.label) {
                errorMsg = this.$t("globalDataModel.emptyName");
            } else if (this.wrongPattern) {
                errorMsg = this.$t("globalDataModel.wrongPattern");
            } else if (this.duplicatedName) {
                errorMsg = this.$t("globalDataModel.duplicateName");
            }
            return errorMsg;
        },
        errorCode() {
            let errorMsgCode;
            if (!this.column.code) {
                if (this.column.label) {
                    errorMsgCode = this.$t("globalDataModel.emptyName");
                }
            } else if (this.wrongPatternErrCode) {
                errorMsgCode = this.$t("globalDataModel.wrongPatternCode");
            } else if (this.duplicatedCode) {
                errorMsgCode = this.$t("globalDataModel.duplicateCode");
            }
            return errorMsgCode;
        },
        isError() {
            return this.emptyName || this.wrongPattern || this.duplicatedName;
        },
        isErrorCode() {
            return (this.emptyCode && !this.isError) || this.wrongPatternErrCode || this.duplicatedCode;
        }

    },
    watch: {
        "column.code": {
            handler(newVal) {
                if (this.isEdit) {
                    return;
                }
                const validatePattern = new RegExp(/^[a-zA-Z0-9_]{1,60}$/);
                this.wrongPatternCode = newVal && !validatePattern.test(newVal);
                this.emptyCode = !newVal && !this.addAnother;
                this.wrongPatternErrCode = this.wrongPatternCode;
                this.duplicatedCode = false;
                const checkCodeForDuplicates = this.atributesList.find(
                    elem => elem.code === newVal
                );
                if (checkCodeForDuplicates) {
                    this.duplicatedCode = true;
                } else {
                    this.duplicatedCode = false;
                }
            }
        },
        attDataToEdit: {
            handler(newValue) {
                if (newValue) {
                    this.column = { ...newValue };
                }
            },
            immediate: true
        }
    },
    validations: {
        columnType: {
            required
        }
    },
    methods: {
        ...mapActions("dataStore", ["addAttributesGDM", "deleteAttribute", "editAttribute"]),
        actionsDlg($event) {
            if ($event === "save") {
                this.$v.$touch();
                this.emptyName = !this.column.label;
                this.emptyCode = !this.column.code;
                if (!this.$v.$invalid && !this.wrongPattern && !this.wrongPatternErrCode
                && !this.duplicatedName && !this.duplicatedCode && !this.emptyName && !this.emptyCode) {
                    const objToSave = {
                        name: this.column.label,
                        type: this.columnType[0].value,
                        code: this.column.code || "",
                        entityCode: this.entityData.code
                    };
                    if (this.isEdit) {
                        const updatePayload = {
                            name: this.column.label,
                            attrCode: this.column.code || "",
                            entityCode: this.entityData.code
                        };
                        if (this.attDataToEdit.label !== this.column.label || this.attDataToEdit.code !== this.column.code) {
                            this.editAttribute(updatePayload).then(() => {
                                this.$toast.showNotify({
                                    message: this.$t("globalDataModel.editedColToast"),
                                    type: "success"
                                });
                                this.$emit("refreshEntity", { ev: "edited", name: this.entityData.name, code: this.entityData.code });
                                this.$emit("closeModal", true);
                                this.$emit("input", false);
                            });
                        } else {
                            this.$emit("refreshEntity", { ev: "edited", name: this.entityData.name, code: this.entityData.code });
                            this.$emit("closeModal", true);
                            this.$emit("input", false);
                        }
                    } else {
                        this.addAttributesGDM(objToSave).then(() => {
                            if (this.addAnother) {
                                this.attUpdated = true;
                                this.updateComponent++;
                                this.column.label = "";
                                this.column.code = "";
                                this.$v.$reset();
                                this.defaultSource = "string";
                                this.$emit("refreshEntity", { ev: "created", name: this.entityData.name, code: this.entityData.code });
                            } else {
                                this.$emit("addAttribute", objToSave);
                                this.$emit("refreshEntity",
                                    { ev: this.addAttInEntity ? "edited" : "created",
                                        name: this.entityData.name,
                                        code: this.entityData.code });
                                this.$emit("closeModal", true);
                                this.$emit("input", false);
                                this.$toast.showNotify({
                                    type: "success",
                                    message: this.$t("globalDataModel.addedColumn"),
                                    timeout: 500
                                });
                            }
                        })
                            .catch((err) => {
                                if (err.response.status === 409) {
                                    if (err.response.data.invalidColumns[0].columnNameInvalid) {
                                        this.showColumnModal = true;
                                        this.duplicatedName = true;
                                    }
                                    if (err.response.data.invalidColumns[0].columnCodeInvalid) {
                                        this.showColumnModal = true;
                                        this.duplicatedCode = true;
                                    }
                                }
                            });
                    }
                }
            } else if ($event === this.$t("globalDataModel.deleteEntity")) {
                this.showDialog = true;
            }
            if ($event === "close") {
                this.$emit("refreshEntity", { ev: "created", name: this.entityData.name, code: this.entityData.code });
                this.$emit("closeModal", true);
                this.$emit("input", false);
            } else if (this.attUpdated) {
                this.$emit("refreshEntity", { ev: "edited", name: this.entityData.name });
            }
        },
        checkColumnName() {
            // eslint-disable-next-line
            const validatePattern = new RegExp(/^[ a-zA-Z0-9_\/\n/-]{1,60}$/);
            this.emptyName = !this.column.label;
            this.wrongPattern = !validatePattern.test(this.column.label);
            const checkNameForDuplicates = this.atributesList.find(
                elem => elem.name === this.column.label
            );
            if (this.attDataToEdit.label === this.column.label) {
                this.duplicatedName = false;
            } else {
                this.duplicatedName = !!checkNameForDuplicates;
            }
        },
        checkNameGenerateCode() {
            this.checkColumnName();
            if (!this.isEdit) {
                this.generateCode();
            }
        },
        generateCode() {
            const camelCode = generateSanitizedCamelIshCase(this.column.label);
            const allCodesSet = this.atributesList.reduce(
                (acc, column) => acc.add(column.code),
                new Set()
            );
            let newCode = camelCode;
            let iterator = 0;
            while (allCodesSet.has(newCode)) {
                iterator++;
                newCode = `${camelCode}${iterator}`;
            }
            this.column.code = newCode;
        },
        removeColumn() {
            const attToDelete = {
                attrCode: this.column.code,
                entityCode: this.entityData.code
            };
            this.deleteAttribute(attToDelete).then(() => {
                this.$toast.showNotify({
                    message: this.$t("globalDataModel.deletedColMsg"),
                    type: "success"
                });
                this.$emit("refreshEntity", { ev: "edited", name: this.entityData.name, code: this.entityData.code });
                this.$emit("input", false);
            });
        }
    }
};
